import { DefaultTrackPromotionEvent } from '@/common/analytics/gtm/shared/trackViewPromotion';
import { HomepageConfig } from '@/modules/HomePage/HomePageConfig';
import { HomepageBrandsFeedItem } from 'generatedBfw/static';

export type BrandshopTrackPromotionEvent = Omit<DefaultTrackPromotionEvent, 'creative_size'>;

export const createBrandshop = (
  brand: HomepageBrandsFeedItem,
  position: number,
): BrandshopTrackPromotionEvent => {
  return {
    promotion_id: `brand|${HomepageConfig.analyticsGaName}|${brand.slug}`,
    promotion_name: brand.name,
    promotion_type: 'brand',
    creative_slot: `brand_slider|${position}`,
    creative_name: brand.coverCoreUrl,
  };
};
